import axios from "axios"
import { User } from "../../../redux/user"
import constants from "../../../constants"
import dayjs, { Dayjs } from "dayjs"
import isoWeek from "dayjs/plugin/isoWeek"
import { SporeTestReportCustomer, SporeTestResultCustomer, UpdateBioboxPracticePayload } from './types'

dayjs.extend(isoWeek)

const getCorpBioTestResults = async (currentUser: User, customerNumber: string, fromDate: Dayjs, toDate: Dayjs) => {
  const from = fromDate.startOf('isoWeek').format('YYYY-MM-DD')
  const to = `&toDate=${toDate.format('YYYY-MM-DD')}`
  let usersGroupMembers = ''

  if (currentUser.users_group_members?.length) {
    usersGroupMembers = `&usersGroupMembers=${currentUser.users_group_members}`
  }

  const { data } = await axios.get(`${constants.ONTRAQ_API_URL}/api2/${customerNumber}/sporetesting-results/biological-calendar-data?fromDate=${from}${to}${usersGroupMembers}`)
  return data
}

const updateBoxPractice = async (boxId: number, biobox: UpdateBioboxPracticePayload, customerNumber: string) => {
  const { data } = await axios.put(`${constants.ONTRAQ_API_URL}/api2/${customerNumber}/sporetesting-boxes/${boxId}/assign-practice`, biobox)
  return data
}

const getResultsByPractice = async (customerNumber: string, groupIds?: number[]) => {
  const queryParams = groupIds?.length
    ? `?group_ids=${JSON.stringify(groupIds)}`
    : ''

  const url = `${constants.ONTRAQ_API_URL}/api2/${customerNumber}/sporetesting-results/results-by-practice${queryParams}`
  const response = await axios.get(url)
  const customers: SporeTestReportCustomer[] = response.data

  return customers
}

const getFailedResultsByPractice = async (customerNumber: string, groups: number[] | null, dateRange: dayjs.Dayjs[] | null) => {  
  let queryParams = groups || dateRange ? '?' : ''

  if (groups) {
    const groupIds = JSON.stringify(groups)

    queryParams += `group_ids=${groupIds}`
  }

  if (dateRange) {
    const delimiter = groups && dateRange ? '&' : ''
    const from = dateRange[0].format('YYYY-MM-DD')
    const to = dateRange[1].format('YYYY-MM-DD')
    const range = JSON.stringify([from, to])

    queryParams += `${delimiter}date_range=${range}`
  }

  const url = `${constants.ONTRAQ_API_URL}/api2/${customerNumber}/sporetesting-results/failed-report${queryParams}`
  const response = await axios.get(url)
  const customers: SporeTestResultCustomer[] = response.data

  return customers
}

export {
  getCorpBioTestResults,
  updateBoxPractice,
  getResultsByPractice,
  getFailedResultsByPractice,
}